import TabPanel from "../../common/TabPanel";
import theme from "../../../theme";
import FormSection from "../../common/FormSection";
import {Checkbox, FormControlLabel, Grid, TextField} from "@material-ui/core";
import {Controller} from "react-hook-form";
import {ErrorMessage} from "@hookform/error-message";
import CurrencyTextField from "@unicef/material-ui-currency-textfield";
import React, {useState} from "react";
import MenuItem from "@material-ui/core/MenuItem";

const FINANCING_COMPANIES = [
  "Alior Leasing",
  "Vehis",
  "Velo Leasing",
  "BNP Paribas",
  "Millennium Leasing",
  "PEKAO Leasing"
];

const CONTRACT_LENGTH_OPTIONS = [12, 24, 36, 48, 60, 72, 84];

const requiredRule = {required: <span className="error">To pole jest wymagane!</span>};
const requiredNumberRule = {
  required: <span className="error">To pole jest wymagane!</span>,
  pattern: {
    value: /^[0-9.]+$/,
    message: <span className="error">Dopuszczalne tylko liczby!</span>
  }
};

const PromotionalOfferTabPanel = ({data, tabValue, form}) => {

  const {control, formState: {errors}, setValue} = form;

  const promotionalOffer = data.promotionalOffer || {};

  const [benefitsPackageChecked, setBenefitsPackageChecked] = useState(
    promotionalOffer.benefitsPackageNet !== null && promotionalOffer.benefitsPackageNet !== undefined
  );
  const [ocAcInsuranceChecked, setOcAcInsuranceChecked] = useState(
    promotionalOffer.ocAcInsuranceNet !== null && promotionalOffer.ocAcInsuranceNet !== undefined
  );
  const [gapInsuranceChecked, setGapInsuranceChecked] = useState(
    promotionalOffer.gapInsuranceNet !== null && promotionalOffer.gapInsuranceNet !== undefined
  );

  const toggleOptionalAmount = (fieldName, checked, setChecked) => {
    setChecked(checked);
    if (!checked) {
      setValue(fieldName, null);
    }
  }

  const optionalAmountField = (fieldName, label, checked, onToggle) => (
    <Grid item xs={12} sm={6} md={4}>
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            checked={checked}
            onChange={(e) => onToggle(fieldName, e.target.checked)}
          />
        }
        label={label}
      />
      <Controller
        name={fieldName}
        control={control}
        defaultValue={promotionalOffer[fieldName.split(".")[1]]}
        render={({field}) => (
          <CurrencyTextField
            {...field}
            value={field.value ?? ""}
            disabled={!checked}
            label="Kwota (zł/mies.)"
            decimalCharacter=","
            digitGroupSeparator=" "
            onChange={(event, value) => field.onChange(value === "" ? null : value)}
            fullWidth
            variant="outlined"
            currencySymbol="PLN"
          />
        )}
      />
    </Grid>
  );

  return (
    <TabPanel value={tabValue} index={5} dir={theme.direction}>
      <FormSection label="Oferta promocyjna">
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <Controller
              name="promotionalOffer.financingCompany"
              control={control}
              rules={requiredRule}
              defaultValue={promotionalOffer.financingCompany}
              render={({field}) => (
                <TextField
                  {...field}
                  select
                  label="Firma finansująca"
                  fullWidth
                  variant="outlined"
                >
                  {FINANCING_COMPANIES.map((company) => (
                    <MenuItem key={company} value={company}>{company}</MenuItem>
                  ))}
                </TextField>
              )}
            />
            <ErrorMessage errors={errors} name="promotionalOffer.financingCompany">
              {({messages}) =>
                messages &&
                Object.entries(messages).map(([type, message]) => (
                  <p key={type}>{message}</p>
                ))
              }
            </ErrorMessage>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Controller
              name="promotionalOffer.availableForConsumer"
              control={control}
              defaultValue={promotionalOffer.availableForConsumer === true}
              render={({field}) => (
                <FormControlLabel
                  control={
                    <Checkbox
                      {...field}
                      color="primary"
                      onChange={(e) => field.onChange(e.target.checked)}
                      checked={field.value}
                    />
                  }
                  label="Oferta dostępna również dla konsumenta?"
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Controller
              name="promotionalOffer.contractLengthMonths"
              control={control}
              rules={requiredRule}
              defaultValue={promotionalOffer.contractLengthMonths}
              render={({field}) => (
                <TextField
                  {...field}
                  select
                  label="Okres leasingu"
                  fullWidth
                  variant="outlined"
                >
                  {CONTRACT_LENGTH_OPTIONS.map((months) => (
                    <MenuItem key={months} value={months}>{months} miesięcy</MenuItem>
                  ))}
                </TextField>
              )}
            />
            <ErrorMessage errors={errors} name="promotionalOffer.contractLengthMonths">
              {({messages}) =>
                messages &&
                Object.entries(messages).map(([type, message]) => (
                  <p key={type}>{message}</p>
                ))
              }
            </ErrorMessage>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Controller
              name="promotionalOffer.installmentNet"
              control={control}
              rules={requiredNumberRule}
              defaultValue={promotionalOffer.installmentNet}
              render={({field}) => (
                <CurrencyTextField
                  {...field}
                  label="Rata miesięczna netto"
                  decimalCharacter=","
                  digitGroupSeparator=" "
                  onChange={(event, value) => field.onChange(value)}
                  fullWidth
                  variant="outlined"
                  currencySymbol="PLN"
                />
              )}
            />
            <ErrorMessage errors={errors} name="promotionalOffer.installmentNet">
              {({messages}) =>
                messages &&
                Object.entries(messages).map(([type, message]) => (
                  <p key={type}>{message}</p>
                ))
              }
            </ErrorMessage>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Controller
              name="promotionalOffer.initialFeeNet"
              control={control}
              rules={requiredNumberRule}
              defaultValue={promotionalOffer.initialFeeNet}
              render={({field}) => (
                <CurrencyTextField
                  {...field}
                  label="Wpłata wstępna netto"
                  decimalCharacter=","
                  digitGroupSeparator=" "
                  onChange={(event, value) => field.onChange(value)}
                  fullWidth
                  variant="outlined"
                  currencySymbol="PLN"
                />
              )}
            />
            <ErrorMessage errors={errors} name="promotionalOffer.initialFeeNet">
              {({messages}) =>
                messages &&
                Object.entries(messages).map(([type, message]) => (
                  <p key={type}>{message}</p>
                ))
              }
            </ErrorMessage>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Controller
              name="promotionalOffer.buyoutValueNet"
              control={control}
              rules={requiredNumberRule}
              defaultValue={promotionalOffer.buyoutValueNet}
              render={({field}) => (
                <CurrencyTextField
                  {...field}
                  label="Wykup końcowy netto"
                  decimalCharacter=","
                  digitGroupSeparator=" "
                  onChange={(event, value) => field.onChange(value)}
                  fullWidth
                  variant="outlined"
                  currencySymbol="PLN"
                />
              )}
            />
            <ErrorMessage errors={errors} name="promotionalOffer.buyoutValueNet">
              {({messages}) =>
                messages &&
                Object.entries(messages).map(([type, message]) => (
                  <p key={type}>{message}</p>
                ))
              }
            </ErrorMessage>
          </Grid>
        </Grid>
      </FormSection>

      <FormSection label="Dodatkowe składniki (opcjonalne)">
        <Grid container spacing={3}>
          {optionalAmountField("promotionalOffer.benefitsPackageNet", "Pakiet korzyści", benefitsPackageChecked,
            (fieldName, checked) => toggleOptionalAmount(fieldName, checked, setBenefitsPackageChecked))}
          {optionalAmountField("promotionalOffer.ocAcInsuranceNet", "Ubezpieczenie OC/AC", ocAcInsuranceChecked,
            (fieldName, checked) => toggleOptionalAmount(fieldName, checked, setOcAcInsuranceChecked))}
          {optionalAmountField("promotionalOffer.gapInsuranceNet", "Ubezpieczenie GAP", gapInsuranceChecked,
            (fieldName, checked) => toggleOptionalAmount(fieldName, checked, setGapInsuranceChecked))}
        </Grid>
      </FormSection>
    </TabPanel>
  );
}

export default PromotionalOfferTabPanel;
